export default {
  bulkOptions: [
    // {
    //   key: 'delete_bulk',
    //   field: 'delete_bulk',
    //   value: 'true',
    //   label: 'Delete',
    //   type: 'danger',
    //   permissionCode: 'billing.delete_rate',
    // },
  ],
  exportImportOptions: {
    export: {
      directly: true,
      url_name: 'api:admin:billing:branchrating:export',
    },
  },
}